export const burgerMenu = (
  <svg width="20" height="12" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 0.5H0M15 8.5H6M15 4.5H9" stroke="white" strokeWidth="1.5px" />
  </svg>
);
